<template>
  <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Revenue Shares', to: '/revenueshares' },
      { label: 'Edit' }
    ]" title="Edit Revenue Shares" />

    <div class="bg-white py-2.5 rounded-lg shadow-sm mb-4">
     <div class="flex-col justify-between py-0 mx-4 pb-4 w-1/2 ">
     <div>
          <label class="block  mt-0 mb-2 font-medium text-gray-700">Revenue Share Name</label>
            <input 
              id="name" 
              type="text" 
              v-model="name" 
              placeholder="Enter Revenue Share Name" 
              :class="[
            'w-full rounded-md px-4 py-2.5 mb-2 text-sm focus:outline-none focus:ring-2',
            submitted && !name ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '
          ]" 
          />
            <p v-if="submitted && !name" class="text-red-500 text-sm mt-0">Must be filled.</p>
        </div>
         <div>
          <label class="block  mt-0 mb-2 font-medium text-gray-700">Description</label>
            <t-textarea  id="description"  type="number" class="rounded-lg mb-4" placeholder="Enter description about revenue share..." 
            v-model="description" >
          </t-textarea>
        </div>
         <div>
          <label class="block  mt-0 mb-2 font-medium text-gray-700">Default Fixed Amount</label>
            <input 
              id="fixedAmount" 
              type="number" 
               v-on:input="setFixed"
              v-model="fixedAmount" 
              placeholder="Enter Value of Default Fixed Amount" 
              :class="[
            'w-full rounded-md px-4 py-2.5 mb-2 text-sm focus:outline-none focus:ring-2',
            submitted && !fixedAmount ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '
          ]" 
          />
          <p v-if="submitted && !fixedAmount" class="text-red-500 text-sm my-0">Must be filled.</p>
          <p class="text-sm text-gray-500 ">Converted data : {{ convertedFixed }}</p>
            
        </div>
         <div class="relative">
          <label class="block  mt-0 mb-2 font-medium text-gray-700">Default Percentage Amount</label>
            <input 
              id="percentageAmount" 
              type="number" 
               v-on:input="setPercentage"
              v-model="percentageAmount" 
              placeholder="Enter Value of Percentage Fixed Amount" 
              :class="[
            'w-full rounded-md px-4 py-2.5 mb-2 text-sm focus:outline-none focus:ring-2',
            submitted && !percentageAmount ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '
          ]" 
          />
          <p v-if="submitted && !percentageAmount" class="text-red-500 text-sm my-0">Must be filled.</p>
            
            <p class="text-sm text-gray-500 ">Converted data : {{ convertedPercentage }}</p>
            <span v-if="percentageAmount?.length > 0" class="absolute inset-y-0 right-3 flex items-center text-gray-500 text-sm">
            %
          </span>
        </div>
          <div class="mb-3 mr-0">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
              Status
            </label>
            <div>
              <button clas type="button" @click="toggleActive" :class="{
                  'bg-blue-700': this.isActive,
                  'bg-gray-300': !this.isActive
                }" class="w-12 h-6 button-active-inactive rounded-full relative transition-colors duration-200 focus:outline-none">
                              <span :class="{
                  'translate-x-6': this.isActive,
                  'translate-x-0': !this.isActive
                }" class="w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200"></span>
              </button>
            </div>
          </div>   
          <div class="flex justify-start">
                <button
                  class="mr-3 text-white bg-blue-700 rounded-lg px-2.5 py-2"
                  type="click"
                 @click="updateRevenueShare"
                >
                  Save
                </button>
               
                <button
                class="bg-white border text-gray-700 rounded-lg px-2.5 py-2"
                  @click="$router.push('/revenueshares')"
                  >Cancel</button
                >
            </div>
    </div>
   
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs.vue';
import {EventBus} from '../../event-bus'

export default {
  name: 'VendorAggrementUpdate',
    components: {
    HeaderBreadcrumbs
  },
  data() {
    return {
      name: '',
      description: '',
      fixedAmount: null,
      submitted:false,
      percentageAmount: null,
      isActive: true,
      convertedFixed: '',
      convertedPercentage: '',
    };
  },
  watch: {
    item: function() {
      if (!Object.keys(this.item).length) return;
      this.getRevenue();
    },
    successMessage: function() {
      if (!this.successMessage) return;
         EventBus.$emit('show-toast', {
            message:'Revenue shares has been updated.',
            type: 'success',
          });
      this.$router.push('/revenueshares');
    },
    errorMessage: function() {
      if (!this.errorMessage) return;
       EventBus.$emit('show-toast', {
            message:this.errorMessage,
            type: 'error',
          });
    },
    isError: function() {
      if (!this.isError) return;
      EventBus.$emit('show-toast', {
            message:'Ops. Something went wrong !',
            type: 'error',
          });
    },
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Update Revenue Share | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.revenueshares.isLoading,
      isError: (state) => state.revenueshares.isError,
      successMessage: (state) => state.revenueshares.successMessage,
      errorMessage: (state) => state.revenueshares.errorMessage,
      item: (state) => state.revenueshares.item,
    }),
  },
  created: function() {
    const revenueID = this.$route.params.id;
    this.fetchRevenueShareByID({ id: revenueID });
  },
  methods: {
    ...mapActions('revenueshares', [
      'fetchRevenueShareByID',
      'editRevenueShare',
    ]),

    getRevenue() {
      const data = this.item;
      this.name = data.name;
      this.description = data.description;
      this.fixedAmount = data.default_fixed_amount;
      this.percentageAmount = (
        parseFloat(data.default_percentage_amount) * 100
      ).toFixed(1);
      this.convertedFixed = parseFloat(data.default_fixed_amount);
      this.convertedPercentage = parseFloat(data.default_percentage_amount);
      this.isActive = data.is_active;
    },

    updateRevenueShare() {
        this.submitted = true;
        if (!this.name || !this.fixedAmount || !this.percentageAmount) {
          return;
        }

      const revenueID = this.$route.params.id;
      const payload = {
        id: revenueID,
        name: this.name,
        description: this.description,
        fixedAmount: this.fixedAmount,
        percentageAmount: this.percentageAmount,
        isActive: this.isActive,
      };

      this.editRevenueShare(payload);
    },

   toggleActive() {
      this.isActive = !this.isActive;
    },
    setFixed() {
      this.convertedFixed = this.fixedAmount;
    },
    setPercentage() {
      this.convertedPercentage = this.percentageAmount
        ? (parseFloat(this.percentageAmount) / 100).toFixed(3)
        : 0;
    },
  },
};
</script>
<style>
.button-active-inactive {
  position: relative;
  display: inline-flex;
  align-items: center;
}
</style>
